import { useState } from 'react';

import Image from 'next/image';
import styled from 'styled-components';
import { useMediaQuery } from '../../hooks/mediaQuery';
import { TextShadow } from '../../shared-components/testimonials/testimonials';
import CitiesSwiper from './CitiesSwiper';
import CitiesDesk from './CitiesDesk';
import dynamic from 'next/dynamic';
const Link = dynamic(() => import('next/link'));
interface IProps {
  title: string;
  subTitle: string;
  FeaturedCities?: any;
  citiesTotalCount: number;
  slug?: string;
}

const OurCities = ({
  title,
  subTitle,
  FeaturedCities,
  citiesTotalCount
}: IProps) => {
  const mediaQuery = useMediaQuery(768);
  return (
    <section className="Our_Cities-wrapper mt-10  w-[90%] lg:w-[85%] 3xl:w-[80%]  max-w-[1750px] mx-auto">
      <div id="header">
        <h2 className="text-[#131313] text-lg lg:text-3xl lg:mb-4  font-semibold ">
          {title}
        </h2>
        <p className="text-[#333333]  text-base lg:text-2xl font-[600]">
          {subTitle}
        </p>
      </div>
      {mediaQuery ? (
        <CitiesSwiper data={FeaturedCities} />
      ) : (
        <CitiesDesk FeaturedCities={FeaturedCities} />
      )}
    </section>
  );
};

export default OurCities;
